module.exports = __webpack_public_path__ + "img/142.4.39803412.png";